export default __webpack_public_path__ + "static/media/tabHome.74278f5c.svg";